// Works out where each captured section goes in the exported PDF, kept free of
// jsPDF and the DOM so the paging rules can be checked on their own.
//
// `elements` are the on-screen sizes of the captured nodes, in CSS px, in the
// order they should appear. The returned placements are in PDF units, and a
// section taller than one page produces several placements — one per page —
// each naming the band of the section it shows (`sourceTop`/`sourceHeight`, in
// the section's own CSS px).
export const planPdfLayout = (elements, { pageWidth, pageHeight, padding }) => {
  const contentWidth = pageWidth - padding * 2;
  const usableHeight = pageHeight - padding * 2;

  const placements = [];
  let page = 0;
  let top = padding;

  const place = (placement) => {
    // a section only moves on if the current page has already been written to,
    // otherwise a tall one would leave an empty page behind it
    if (top > padding && top + placement.height > pageHeight - padding) {
      page += 1;
      top = padding;
    }

    placements.push({ ...placement, page, x: padding, y: top });
    top += placement.height + padding;
  };

  elements.forEach(({ width, height }, index) => {
    if (!width || !height) return;

    // only ever scale down, and scale both axes by the same factor so nothing
    // comes out stretched
    const scale = Math.min(1, contentWidth / width);
    const drawWidth = width * scale;
    const drawHeight = height * scale;

    if (drawHeight <= usableHeight) {
      place({
        index,
        part: 0,
        width: drawWidth,
        height: drawHeight,
        sourceTop: 0,
        sourceHeight: height,
      });
      return;
    }

    // Taller than a page. Cut it into page-high bands rather than shrinking it
    // until it fits — that is what made the switch list unreadable.
    const bandHeight = usableHeight / scale;
    let part = 0;

    for (let sourceTop = 0; sourceTop < height; sourceTop += bandHeight) {
      const sourceHeight = Math.min(bandHeight, height - sourceTop);

      place({
        index,
        part,
        width: drawWidth,
        height: sourceHeight * scale,
        sourceTop,
        sourceHeight,
      });

      part += 1;
    }
  });

  return placements;
};
